<template>
  <div class="nail-to-bottom">
    <div
      v-for="(notification, key) in notifications"
      :key="key"
      class="flex justify_between mx2 my1 pa2"
      :style="getNotificationStyle(notification.type)"
    >
      {{ notification.message }}
      <span @click="close(key)">X</span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'notifications',

  data() {
    return {
      notifications: {},
    };
  },

  created() {
    this.$bus.$on('notification', (message, type = 'warning') => {
      // Make sure we never display the same notifcation:
      const exists = !!Object.values(this.notifications).find(obj => obj.message === message);
      if (exists) { return; }

      const showTimeInMS = 5000;
      const key = this.$uuid.v4();
      this.$set(this.notifications, key, { message, type });
      setTimeout(() => { this.$delete(this.notifications, key); }, showTimeInMS);
    });
  },

  methods: {
    close(key) {
      this.$delete(this.notifications, key);
    },

    getNotificationStyle(type) {
      const styling = this.$CONSTANTS.messageTypes[type] || this.$CONSTANTS.messageTypes.default;
      return `color: ${styling.color}; background: ${styling.backgroundColor};`;
    },
  },
};
</script>

<style lang="scss" scoped>
div { z-index: 99; }

.nail-to-bottom {
  position: fixed;
  bottom: 0;
  width: $app_screen_width;
}
</style>
